import * as React from 'react';
import {
  Card,
  CardBody,
  TabStrip,
  TabStripTab,
} from '@progress/kendo-react-layout';
import SystemSettings from '../../../SystemSetting/Pages/SystemSettings';
import UserCredentials from '../../../UserCredential/Pages/UserCredentials';
import { isComponentUpdate } from 'smart-react';
/**
 * Test Details Desktop view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The DesktopView component.
 */
const DesktopView = ({
  selected,
  handleSelect,
  detailsDataModified,
  state,
}) => {
  const [integrationConnection, setIntegrationConnection] = React.useState(
    state.dataSet,
  );
  React.useEffect(() => {
    setIntegrationConnection(state.dataSet);
  }, [state]);
  return (
    <>
      <Card>
        <TabStrip
          className='page-tabs'
          selected={selected}
          onSelect={handleSelect}
        >
          <TabStripTab
            title='Setting'
            contentClassName={`tabs-card !k-px-0 !k-py-0 ${
              detailsDataModified === true ? 'tab-modified' : ''
            }`}
          >
            <Card
              className={`tabs-card ${
                detailsDataModified === true ? 'tab-modified' : ''
              }`}
            >
              <CardBody>
                <div className='card-body'>
                  <SystemSettings
                    integrationConnection={integrationConnection}
                  />
                </div>
              </CardBody>
            </Card>
          </TabStripTab>
          <TabStripTab
            title='User Credential'
            contentClassName={`tabs-card !k-px-0 !k-py-0 ${
              detailsDataModified === true ? 'tab-modified' : ''
            }`}
          >
            <Card
              className={`tabs-card ${
                detailsDataModified === true ? 'tab-modified' : ''
              }`}
            >
              <CardBody>
                <div className='card-body'>
                  <UserCredentials
                    integrationConnection={integrationConnection}
                  />
                </div>
              </CardBody>
            </Card>
          </TabStripTab>
        </TabStrip>
      </Card>
    </>
  );
};

// Export the memoized component
export default React.memo(DesktopView, isComponentUpdate);
